import React from 'react';
import './CanterburyChristChurchUni.css'; // Assume custom CSS for styling

const universityData = [
    { category: 'Year Founded', detail: '1962 (University status granted in 2005)' },
    { category: 'Courses Offered', detail: 'Business, Engineering, Law, Nursing, Education, Creative Arts, Psychology, Public Health, and more' },
    { category: 'Admission Periods', detail: 'Undergraduate via UCAS: Jan–June; Postgraduate: Rolling admissions' },
    { category: 'English Level Requirement', detail: 'IELTS 6.0–6.5 (no band below 5.5); TOEFL iBT 80; PTE 50+' },
    { category: 'Scholarships', detail: '£1,500/year International Student Scholarship; Sanctuary & Sports Scholarships available' },
    { category: 'International Student Office', detail: 'Dedicated support team, pre-arrival guidance, visa help, and integration programs' },
    { category: 'Admin & Contact', detail: ' ipo@canterbury.ac.uk | +44 (0)1227 782222 | www.canterbury.ac.uk' },
    { category: 'Tuition Fees', detail: '£13,000–£15,500/year for international students (varies by course)' },
    { category: 'Why Study Here?', detail: 'Top UK employment outcomes, inclusive campus, modern facilities, UNESCO heritage location, strong teaching reputation' },
    { category: 'Ranking in UK', detail: 'Complete University Guide: #99; Guardian Guide: #107; QS World Ranking: 1201–1400' },
];

const CanterburyChristChurchUni = () => {
    return (
        <div className="table-container">
            <h2>Canterbury Christ Church University Facts</h2>
            <table className="styled-table">
                <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
                </thead>
                <tbody>
                {universityData.map((item, index) => (
                    <tr key={index}>
                        <td>{item.category}</td>
                        <td>{item.detail}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default CanterburyChristChurchUni;
